import React from "react"

import { Card, Checkbox } from "components"
import classes from "./StrmrmfsFoodCard.module.scss"

const StrmrmfsFoodCard = props => {
  const {
    food,
    selectedFoodOptions,
    setSelectedFoodOptions
  } = props

  const handleSelectAll = (checked, food) => {
    setSelectedFoodOptions(prev => {
      const previousFoodIds = { ...prev }

      checked
        ?
        food.options.forEach(option => {
          previousFoodIds[option._id] = {
            foodId: food._id,
            optionId: option._id,
            foodName: food.name,
            unit: food.unit,
            isSimple: food.options.length === 1,
            foodOptionName: option.name,
            foodImageCover: food.imageCover
          }
        })
        :
        food.options.forEach(option => {
          delete previousFoodIds[option._id]
        })

      return previousFoodIds
    })
  }

  const handleSelect = (checked, food, option) => {
    setSelectedFoodOptions(prev => {
      const previousFoodIds = { ...prev }

      if (checked) {
        previousFoodIds[option._id] = {
          foodId: food._id,
          optionId: option._id,
          foodName: food.name,
          unit: food.unit,
          isSimple: food.options.length === 1,
          foodOptionName: option.name,
          foodImageCover: food.imageCover
        }
      } else {
        delete previousFoodIds[option._id]
      }

      return previousFoodIds
    })
  }

  const isSimple =
    food.options.length === 1

  const isAllOptionsSelected =
    food.options.every(option =>
      !!selectedFoodOptions[option._id]
    )

  return (
    <Card className={classes["card"]}>
      <div className={classes["header"]}>
        <div className={classes["food-name"]}>
          {food.name}
        </div>
        <Checkbox
          checked={isAllOptionsSelected}
          onChange={(checked) => handleSelectAll(checked, food)}
        />
      </div>
      {
        !isSimple &&
        <div className={classes["body"]}>
          {food.options.map(option =>
            <div
              key={option._id}
              className={classes["option"]}
            >
              <span className={classes["option-name"]}>
                - {option.name}
              </span>
              <Checkbox
                checked={!!selectedFoodOptions[option._id]}
                onChange={(checked) => handleSelect(checked, food, option)}
              />
            </div>
          )}
        </div>
      }
    </Card>
  )
}

export default StrmrmfsFoodCard